import { motion } from "framer-motion";

/**
 * Reveal — scroll-triggered fade + rise using framer-motion `whileInView`.
 * Uses IntersectionObserver under the hood and only runs the animation once.
 */
export default function Reveal({
  children,
  as = "div",
  delay = 0,
  y = 40,
  duration = 0.8,
  className,
  style,
  ...rest
}) {
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration, delay, ease: [0.4, 0, 0.2, 1] }}
      className={className}
      style={style}
      {...rest}
    >
      {children}
    </Comp>
  );
}
